'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'நேரத்தைத் தேர்ந்தெடுக்கவும்'
};

exports['default'] = locale;